/**
 * LP Klaviyo Capture — shared email capture utility
 * Usage: await lpKlaviyoCapture({ email, source, listId, companyId })
 */
window.lpKlaviyoCapture = async function (opts) {
  var headers = {
    'Content-Type': 'application/json',
    'revision': '2024-10-15'
  };
  var companyId = opts.companyId || 'Kh2ryY';

  var results = await Promise.all([
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: opts.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: opts.email,
                  properties: opts.properties || {}
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: opts.listId
              }
            }
          }
        }
      })
    }),
    fetch('https://a.klaviyo.com/client/events/?company_id=' + companyId, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: opts.eventName || opts.source
                }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: opts.email
                }
              }
            },
            properties: {
              source: opts.source,
              page_url: window.location.href
            }
          }
        }
      })
    })
  ]);

  return results;
};
